/* eslint-disable max-len */
import BaseService, { CATEGORY_PORTAL } from "./core/BaseService";

/**
 * API[実施中一覧取得: /onGoing/gridList]のペイロードを表すインターフェース。
 * @export
 * @interface
 *
 * @property {integer} pageNo ページ番号(任意)
 * @property {integer} pageSize 1ページあたりの表示件数(任意)
 */
export interface OnGoingGridListPayload {
    pageNo?: number;
    pageSize?: number;
}

/**
 * API[実施中一覧取得: /onGoing/gridList]の正常応答を表すインターフェース。
 * @export
 * @interface
 * @property onGoingGridList 実施中一覧リスト
 */
export interface OnGoingGridListResponse {
    onGoingGridList: OnGoingGridListItem[];
}

export interface OnGoingGridListItem {
    compulsoryId: string;
    compulsoryName: string;
    careerTitle: string;
    classTitle: string;
    jissiKikan: string;
    status: string;
    imstatListStatusId: number;
    jukou: string;
    jissiStartDateODT: string;
    jissiEndDateODT: string;
    careerId: string;
    careerTypeId: string;
    classId: string;
    enqueteDispFlg: boolean;
    taskReportOkFlg: boolean;
    testFlg: boolean;
    progress: string;
    classStatus: string;
    appChangeOkFlg: boolean;
    appCancelOkFlg: boolean;
    lecCancelOkFlg: boolean;
    appResultOkFlg: boolean;
    classroom: string;
    careerImageUrl: string;
    multiApplyFlag: string;
    displayStartDateTime: string;
    displayEndDateTime: string;
    outOfPeriodFlg: boolean;
    kadai: string;
    kadaiWithin: number;
    enquete: string;
    enqueteWithin: number;
    aplType: string;
}

/**
 * API[実施中一覧取得: /onGoing/gridList]用のサービスクラス。
 */
class OnGoingGridListService extends BaseService {
    constructor() {
        super(CATEGORY_PORTAL, "onGoing/gridList");
    }

    public async fetch(payload?: OnGoingGridListPayload): Promise<OnGoingGridListResponse> {
        return super.postWithPromise(payload).then((json: unknown) => {
            const response = json as OnGoingGridListResponse;
            return response;
        });
    }
}

export default OnGoingGridListService;
